import React, { createContext, useContext } from 'react';
import { useImmersiveScroll } from '../hooks/useImmersiveScroll';

const ImmersiveScrollContext = createContext({
  isHidden: false,
  isAtTop: true,
  scrollDirection: 'up',
  shouldShowBanner: true,
});

export function ImmersiveScrollProvider({ children }) {
  const scrollState = useImmersiveScroll();
  
  return (
    <ImmersiveScrollContext.Provider value={scrollState}>
      {children}
    </ImmersiveScrollContext.Provider>
  );
}

export function useImmersiveScrollContext() {
  return useContext(ImmersiveScrollContext);
}

export default ImmersiveScrollContext;
